import { useConmatTestDetailQuery } from '@innovamat/glow-api-client';
import type { ConmatTestDetail } from '../modules/report/conmat-test-detail';

type Props = {
  testClassroomUuid: string;
  classroomId: string;
  enabled?: boolean;
};

type UseConmatTestDetail = {
  data?: ConmatTestDetail;
  isLoading: boolean;
  error: Error | null;
};

function useConmatTestDetail({
  testClassroomUuid,
  classroomId,
  enabled = true,
}: Props): UseConmatTestDetail {
  const { data, isLoading, error } = useConmatTestDetailQuery(
    {
      testClassroomUuid: testClassroomUuid,
      classroomId: classroomId,
    },
    {
      enabled: !!testClassroomUuid && !!classroomId && enabled,
    }
  );

  return {
    data: data?.conmatTestDetail as ConmatTestDetail,
    isLoading,
    error: (error as Error) || null,
  };
}

export { useConmatTestDetail };
